import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import omitBy from 'lodash/omitBy';
import reject from 'lodash/reject';

/**
 * A utility function to recursively omit values from an input object or array
 * based on the provided predicate.
 *
 * @param input The input object or array to process.
 * @param predicate The predicate to determine which values to omit.
 */
export function deepOmitBy<TInput = unknown, TResult = unknown>(
  input: TInput,
  predicate: (value: TInput[keyof TInput]) => boolean,
): TResult {
  if (isPlainObject(input)) {
    return omitBy(
      // lodash does not have type assertion
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      mapValues(input as any, (value) => deepOmitBy(value as any, predicate)),
      predicate,
    ) as TResult;
  }

  if (isArray(input)) {
    return reject(
      // lodash does not have type assertion
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map(input, (value) => deepOmitBy(value, predicate)) as any,
      predicate,
    ) as TResult;
  }

  return input as unknown as TResult;
}
